/**
 * One line per thing a Trainer showed to both players, yours first: each hand for Lass ("Lass: your hand: Bill,
 * Potion", "Lass: Player Two's hand: nothing"), or the cards a player showed for Pokémon Trader ("Pokémon Trader:
 * you showed Machop, Kadabra").
 *
 * @param {{label: string, hands?: Array<{user_id: number, card_ids: number[]}>, shown?: Array<{user_id: number, card_ids: number[]}>}} revealed
 *   the game's `revealed`
 * @param {(id: number) => string} cardName
 * @param {number} playerId the viewer
 * @param {string} opponentName
 * @returns {string[]}
 */
export function revealedLines(revealed, cardName, playerId, opponentName) {
  const yoursFirst = (a, b) => (a.user_id === playerId ? -1 : 0) - (b.user_id === playerId ? -1 : 0);
  const cards = (cardIds) => (cardIds.length ? cardIds.map(cardName).join(', ') : 'nothing');

  if (revealed.shown) {
    return [...revealed.shown].sort(yoursFirst).map(({ user_id: userId, card_ids: cardIds }) => (
      `${revealed.label}: ${userId === playerId ? 'you' : opponentName} showed ${cards(cardIds)}`
    ));
  }

  return [...revealed.hands].sort(yoursFirst).map(({ user_id: userId, card_ids: cardIds }) => {
    const whose = userId === playerId ? 'your hand' : `${opponentName}'s hand`;
    return `${revealed.label}: ${whose}: ${cards(cardIds)}`;
  });
}
